import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Product } from '../../types/product';
import { ProductTile } from './ProductTile';
type ProductSectionProps = {
  title: string;
  subtitle?: string;
  link?: {
    to: string;
    label: string;
  };
  products: Product[];
  tone?: 'beauty' | 'living';
};
export function ProductSection({
  title,
  subtitle,
  link,
  products,
  tone = 'beauty'
}: ProductSectionProps) {
  const living = tone === 'living';
  return <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-506" data-mp="3cco0uzgyt9ew">
      <div className="mb-8 flex items-end justify-between gap-6 lg:mb-10" data-id="element-507" data-mp="3c9s1r7tdseov">
        <div data-id="element-508" data-mp="2xelzmvxep00t">
          <h2 className={living ? 'text-3xl font-semibold tracking-tight text-ink sm:text-4xl' : 'font-display text-4xl uppercase tracking-display text-ink sm:text-5xl'} data-id="element-509" data-mp="2xh83akh6evdr">
            {title}
          </h2>
          {subtitle && <p className="mt-2 font-light text-muted" data-id="element-510" data-mp="1qyjny8gf7766">{subtitle}</p>}
        </div>
        {link && <Link to={link.to} className={`group hidden shrink-0 items-center gap-1.5 whitespace-nowrap sm:inline-flex ${living ? 'font-semibold text-majorelle' : 'text-xs font-semibold uppercase tracking-[0.14em] text-ink'}`} data-id="element-511" data-mp="1nojk6xod8sti">
            {link.label}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-512" data-mp="1rq56f9msijgd" />
          </Link>}
      </div>
      <ul className={`grid grid-cols-2 lg:grid-cols-4 ${living ? 'gap-3 sm:gap-5' : 'gap-x-4 gap-y-12 lg:gap-x-6'}`} data-id="element-513" data-mp="26luhicqftc6b">
        {products.map(p => <li key={p.slug} data-id="element-514" data-mp="2fg8wee722kow">
            <ProductTile product={p} data-id="element-515" data-mp="2ffhdo3yk4hg1" />
          </li>)}
      </ul>
      {link && <Link to={link.to} className={`mt-8 flex h-12 items-center justify-center border text-sm font-semibold sm:hidden ${living ? 'rounded-lg border-majorelle text-majorelle' : 'border-ink uppercase tracking-[0.14em]'}`} data-id="element-516" data-mp="2bfoyv9iklf28">
          {link.label}
        </Link>}
    </section>;
}